// Pull out some of the very yucky JSX stuff so Gamelobby.js is less... terrible.
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormGroup, TextField,
    DialogContentText, FormControlLabel, Switch
} from '@mui/material/';

import { getSortedPlayersByGain, capitalize } from '../../util/utils'
import AnimatedScorebox from '../AnimatedScorebox';

export const solveTimer = (gameObjects) => {
    return <p style={{ color: gameObjects.curPlayer.solveTime && !gameObjects.roundOver ? 'var(--positive)' : 'var(--time)' }} name="playerTime">{
        (!gameObjects.roundOver ?
            (gameObjects.curPlayer.solveTime ?
                ((gameObjects.curPlayer.solveTime - gameObjects.startTime) / 1000).toFixed(3)
                : (((+new Date()) - gameObjects.startTime) / 1000).toFixed(1))
            : "Waiting for round to start...")
    }</p>
}

export const roundOverPopup = (gameObjects, roundboxOpen, handleRoundboxClose) => {
    return <Dialog open={roundboxOpen} onClose={handleRoundboxClose}>
        <DialogTitle>Round Over!</DialogTitle>
        <DialogContent>
            <AnimatedScorebox players={getSortedPlayersByGain(gameObjects)} gameObjects={gameObjects} />
        </DialogContent>
        <DialogActions>
            <Button onClick={handleRoundboxClose}>Close</Button>
        </DialogActions>
    </Dialog>
}

export const settingsPopup = (settingsOpen, handleSettingsClose, gameObjects, theme, toggleTheme, handleSettingsSave) => {
    return <Dialog open={settingsOpen} onClose={handleSettingsClose}>
        <DialogTitle>Settings</DialogTitle>
        <DialogContent>
            <div className="rowflex">
                <DialogContentText>Username: </DialogContentText>
                <TextField
                    margin="dense"
                    id="settingsName"
                    fullWidth
                    autoComplete='off'
                    InputProps={{ spellCheck: false }}
                    variant="standard"
                    defaultValue={gameObjects.curPlayer.name ? gameObjects.curPlayer.name : ""}
                />
            </div>
            <FormGroup className='rowflex'>
                <FormControlLabel control={<Switch checked={theme === 'dark'} onChange={toggleTheme} />} label={capitalize(theme) + " Mode"} />
            </FormGroup>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleSettingsSave}>Save</Button>
        </DialogActions>
    </Dialog>
}